import menus from 'common/constants/menus';

export const getMenu = (path: string) =>
  menus.filter((itme) => itme.path === path)[0]?.title || '';
